import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Thinking from "@/pages/Thinking";
import ThinkingDetail from "@/pages/ThinkingDetail";
import Building from "@/pages/Building";
import BuildingDetail from "@/pages/BuildingDetail";
import Philosophy from "@/pages/Philosophy";
import Artifacts from "@/pages/Artifacts";
import ArtifactDetail from "@/pages/ArtifactDetail";
import Acknowledgements from "@/pages/Acknowledgements";
import Media from "@/pages/Media";
import Contact from "@/pages/Contact";
import Coaching from "@/pages/Coaching";
import Speaking from "@/pages/Speaking";
import NotFound from "@/pages/NotFound";

export default function App() {
  return (
    <div className="App bg-ink-base text-paper-primary">
      {/* Skip link for keyboard users */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:bg-ink-base focus:text-paper-primary focus:border focus:border-gold focus:px-3 focus:py-2 font-mono text-xs uppercase tracking-[0.18em]"
      >
        Skip to content
      </a>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/thinking" element={<Thinking />} />
          <Route path="/thinking/:slug" element={<ThinkingDetail />} />
          <Route path="/building" element={<Building />} />
          <Route path="/building/:slug" element={<BuildingDetail />} />
          <Route path="/philosophy" element={<Philosophy />} />
          <Route path="/artifacts" element={<Artifacts />} />
          <Route path="/artifacts/:slug" element={<ArtifactDetail />} />
          <Route path="/acknowledgements" element={<Acknowledgements />} />
          <Route path="/media" element={<Media />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/coaching" element={<Coaching />} />
          <Route path="/speaking" element={<Speaking />} />

          {/* Legacy path redirects (client-side; server 301 recommended once deployed) */}
          <Route path="/aboutus" element={<Navigate to="/about" replace />} />
          <Route path="/aboutus/*" element={<Navigate to="/about" replace />} />
          <Route path="/projects-1" element={<Navigate to="/building" replace />} />
          <Route path="/projects-1/*" element={<Navigate to="/building" replace />} />
          <Route path="/projects" element={<Navigate to="/building" replace />} />
          <Route path="/work" element={<Navigate to="/building" replace />} />
          <Route path="/blog" element={<Navigate to="/thinking" replace />} />
          <Route path="/writing" element={<Navigate to="/thinking" replace />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
